import React from "react";
import { Check } from "lucide-react";
import HologramHero from "../components/HologramHero";
import AiBadge from "../components/AiBadge";
import Icon from "../components/Icon";
import { IMAGES } from "../data/content";
import { useI18n } from "../i18n/LanguageContext";

const withBreaks = (lines = []) =>
  lines.map((l, i) => (
    <React.Fragment key={i}>
      {l}
      {i < lines.length - 1 && <br />}
    </React.Fragment>
  ));

export default function Branchen() {
  const { t } = useI18n();
  const b = t.branchen;

  return (
    <div data-testid="page-branchen">
      <HologramHero
        label={b.hero.label}
        image={IMAGES.heroBranchen}
        title={withBreaks(b.hero.titleLines)}
        subtitle={b.hero.subtitle}
        paragraphs={b.hero.paragraphs}
        badges={b.hero.badges}
        cards={b.hero.cards}
      />

      {/* Branch cards */}
      <section className="py-20 bg-white" data-testid="branchen-cards">
        <div className="max-w-[1320px] mx-auto px-5 lg:px-8">
          <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-6">
            {b.branches.map((br) => (
              <div
                key={br.title}
                data-testid={`branch-card-${br.icon.toLowerCase()}`}
                className="card-hover relative bg-white border border-line rounded-2xl pt-6 px-6 pb-14 flex flex-col"
              >
                <Icon name={br.icon} size={30} className="text-blue-brand mb-4" strokeWidth={1.6} />
                <AiBadge className="absolute bottom-3 right-3" />
                <h3 className="font-head font-bold text-ink uppercase tracking-wide text-[13px] mb-3 leading-tight">{br.title}</h3>
                <p className="text-[13px] text-muted-foreground leading-relaxed mb-4">{br.desc}</p>
                <div className="h-28 rounded-xl bg-cover bg-center mb-5" style={{ backgroundImage: `url(${br.image})` }} />
                <ul className="space-y-2 mt-auto">
                  {br.points.map((p) => (
                    <li key={p} className="flex items-start gap-2 text-[13px] text-ink">
                      <Check size={14} className="text-blue-brand mt-0.5 shrink-0" strokeWidth={3} />
                      {p}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Weitere Branchen */}
      <section className="py-16 section-soft" data-testid="branchen-more">
        <div className="max-w-[1320px] mx-auto px-5 lg:px-8">
          <div className="grid lg:grid-cols-[1.4fr_2fr] gap-10 items-center">
            <div className="flex gap-5">
              <Icon name="Globe" size={42} className="text-blue-brand shrink-0" strokeWidth={1.4} />
              <div>
                <h3 className="font-head font-bold text-ink uppercase tracking-wide text-lg mb-3">{b.moreTitle}</h3>
                <p className="text-sm text-muted-foreground leading-relaxed">{b.moreDesc}</p>
              </div>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-5 gap-6">
              {b.moreBranches.map((m) => (
                <div key={m.label} className="text-center">
                  <Icon name={m.icon} size={30} className="text-ink mx-auto mb-3" strokeWidth={1.4} />
                  <p className="text-[12px] text-muted-foreground leading-tight">{m.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
